// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"NextBtn__pc_only___1WRsi","sp_only":"NextBtn__sp_only___2WWZY","next_btn":"NextBtn__next_btn___21Lnv"};